import React, { SyntheticEvent } from 'react';
import { Async, components } from 'react-select';
import GraphQLClient from '@api/graphql/GraphQLClient';
import * as Queries from '@api/graphql/queries';
import { ProductAutocomplete, ProductStatus } from '@api/graphql/types';
import DeleteButton from '@components/DeleteButton';
import { compose } from 'react-apollo';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import { PlaceholderProps } from 'react-select/lib/components/Placeholder';

export interface ProductIdName {
    id: string;
    name: string;
}
interface ProductValueLabel {
    value: string;
    label: string;
}

type Props = {
    name: string;
    value: ProductIdName[] | null | undefined;
    onChange: (value: any, name: string) => void;
} & InjectedIntlProps;


interface State {
    value: ProductIdName[] | null | undefined;
    selectedProducts: ProductValueLabel[];
    inputValue: string;
    results: Array<{value: string, label: string}>;
}

const Placeholder = (props: PlaceholderProps<any>) => {
    return <components.Placeholder {...props} />;
};

class ProductInput extends React.Component<Props, State> {

    public constructor(props: Props) {
        super(props);
        this.state = {
            selectedProducts: [],
            value: props.value ? [...props.value] : [],
            inputValue: '',
            results: [],
        };
    }

    public componentWillReceiveProps(props: Props) {
        this.setState({
            value: props.value ? [...props.value] : [],
        });
    }

    private handleRemove = (index: number) => {
        const newValue = this.state.value ? this.state.value.filter((value, elIndex) => {
            return elIndex !== index;
        }) : [];
        this.props.onChange(newValue, this.props.name);
    }

    private handleRemoveAll = () => {
        this.props.onChange([], this.props.name);
    }

    private handleAdd = (e: SyntheticEvent) => {
        e.preventDefault();
        if (this.state.selectedProducts && this.state.selectedProducts.length > 0) {
            const newValue = this.state.value ? [...this.state.value, ...this.convert(this.state.selectedProducts)] : [this.state.value];
            this.setState({selectedProducts: []}, () => this.props.onChange(newValue, this.props.name));
        }
    }

    private convert = (selectedProducts: ProductValueLabel[]): ProductIdName[] => {
        return selectedProducts.map((selectedProduct: ProductValueLabel) => {
            return {
                id: selectedProduct.value,
                name: selectedProduct.label,
            };
        });
    }

    private move = (index: number, direction: number) => () => {
        const value = [...this.state.value!];
        value[index] = this.state.value![(index + direction)];
        value[(index + direction)] = this.state.value![index];
        this.props.onChange(value, this.props.name);
    }

    private renderField = (value: any, index: number) => {
        return (
            <div className="row" key={`${name}-${index}`} style={{marginBottom: '5px'}}>
                <div className="col-sm-2">
                    {value.id}
                </div>
                <div className="col-sm-7">
                    {value.name}
                </div>
                <div className="col-sm-1">
                    {index !== 0 && <a onClick={this.move(index, -1)} className="pull-left"><i className="fa fa-chevron-up" /></a>}
                    {index !== (this.state.value!.length - 1) && <a className="pull-right" onClick={this.move(index, +1)}><i className="fa fa-chevron-down" /></a>}
                </div>
                <div className="col-sm-2">
                    <DeleteButton
                        className="btn-block"
                        onClick={this.handleRemove}
                        value={index}
                    />
                </div>
            </div>
        );
    }

    private loadOptions = () => {
        const values = this.state.value ? this.state.value.map((val) => val.id) : [];
        return new Promise(resolve => {
            const filters = {
                name: parseInt(this.state.inputValue, 10) ? undefined : this.state.inputValue,
                ext_id: parseInt(this.state.inputValue, 10) ? this.state.inputValue : undefined,
                productStatus: [ProductStatus.AVAILABLE],
            };

            GraphQLClient.query<ProductAutocomplete>({query: Queries.productAutocomplete, variables: {filters, count: 30, page: 1}})
                .then(options => {
                    if (options.data.adminProducts && options.data.adminProducts.data) {
                        const results = (options.data.adminProducts.data.filter((product) => {
                            return !values.includes(product.id);
                        })
                        .map((product) => {
                            return {value: product.id, label: `${product.name} (${product.ext_id})`};
                        }));
                        this.setState({ results });
                        resolve(results);
                    }
                });
        });
    }

    public render() {

        return (
            <>
                {this.props.value ? this.props.value.map(this.renderField) : null}
                <div className="row">
                    <div className="col-sm-10 dropdownPadding">
                        <Async
                            components={{ Placeholder }}
                            placeholder={this.props.intl.formatMessage({ id: 'component.ProductInput.placeholder' })}
                            isMulti={true}
                            defaultOptions={this.state.results}
                            loadOptions={this.loadOptions}
                            value={this.state.selectedProducts}
                            inputValue={this.state.inputValue}
                            onInputChange={(query: string) => this.setState({ inputValue: query })}
                            onChange={(value: ProductValueLabel[]) => this.setState({ selectedProducts: value })}
                            closeMenuOnSelect={false}
                        />
                    </div>
                    <div className="col-sm-2">
                        <button className="btn btn-primary btn-block" onClick={this.handleAdd}>{this.props.intl.formatMessage({ id: 'common.add' })}</button>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-4 pull-right">
                        <DeleteButton
                            className="btn-block"
                            onClick={this.handleRemoveAll}
                            modalBody={<p>{this.props.intl.formatMessage({id: 'module.promotionCategory.deleteAllDialog.body'})}</p>}
                        >{this.props.intl.formatMessage({ id: 'module.promotionCategory.deleteAll.title' })}</DeleteButton>
                    </div>
                </div>
            </>
        );
    }
}

export default compose(
    injectIntl,
)(ProductInput);



// WEBPACK FOOTER //
// ./src/modules/PromotionCategory/components/ProductInput.tsx